const TermsComponent: React.FC = () => {
    
    return (<></>)
}

export default TermsComponent;